import * as React from 'react';

import classNames from 'classnames';

import styles from './typing-indicator.module.css';

type Props = {
    animationDelay: number;
    marginLeft?: boolean;
};

export const TypingDot = (props: Props) => {
    return (
        <div
            style={{
                animationDelay: `${props.animationDelay}s`,
            }}
            className={classNames(styles['typing-dot'], {
                [styles['typing-dot--with-margin']]: props.marginLeft,
            })}
        ></div>
    );
};
